export const CHANGE_CHANNELS_TYPE = 'CHANGE_CHANNELS_TYPE'
